/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Запрос на аутентификацию
 */
export interface LoginSsoReq {
  /**
   * Логин
   * @example user
   */
  login: string;

  /**
   * Пароль
   * @example secret
   */
  password: string;

  /**
   * URI для обратной переадресации после успешной аутентификации
   * @example /own-farm/main
   */
  callbackURI: string;

  /**
   * Уникальное имя внешнего партнера для формирования полного адреса forwardURL=baseURL(partnerName) + callbackURI
   * @example own-farm
   */
  partnerName: string;
}

/**
 * Результат аутентификации
 */
export interface LoginSsoResp {
  /**
   * URL, на который будет переадресован пользователь, вместе с токеном авторизации
   * @example http://some.domain.zone:8080/own-farm/main?token=some.jwt.token
   */
  forwardURL: string;
}

/**
 * Запрос на аутентификацию
 */
export interface GetRefreshTokenReq {
  /**
   * Логин
   * @example user
   */
  login: string;

  /**
   * Пароль
   * @example secret
   */
  password: string;
}

/**
 * Код ошибки
 */
export enum ErrorCode {
  VALIDATION_ERROR = "VALIDATION_ERROR",
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  PARSING_ERROR = "PARSING_ERROR",
  AUTH1 = "AUTH_1",
  AUTH2 = "AUTH_2",
  AUTH3 = "AUTH_3",
  AUTH4 = "AUTH_4",
  AUTH6 = "AUTH_6",
  AUTH7 = "AUTH_7",
  AUTH8 = "AUTH_8",
  AUTH9 = "AUTH_9",
  AUTH50 = "AUTH_50",
  AUTH51 = "AUTH_51",
  AUTH100 = "AUTH_100",
  AUTH101 = "AUTH_101",
  AUTH102 = "AUTH_102",
  AUTH103 = "AUTH_103",
  AUTH104 = "AUTH_104",
  AUTH105 = "AUTH_105",
  AUTH106 = "AUTH_106",
  AUTH108 = "AUTH_108",
  AUTH109 = "AUTH_109",
  AUTH110 = "AUTH_110",
  AUTH111 = "AUTH_111",
  AUTH112 = "AUTH_112",
  AUTH113 = "AUTH_113",
  AUTH160 = "AUTH_160",
  AUTH161 = "AUTH_161",
  AUTH187 = "AUTH_187",
  AUTH190 = "AUTH_190",
  FORBIDDEN = "FORBIDDEN",
  II00001 = "II00001",
  ID00002 = "ID00002",
  II00003 = "II00003",
  II00004 = "II00004",
  SE00002 = "SE00002",
}

export interface ErrorInfo {
  /**
   * Сообщение об ошибке
   * @example Ошибка обработки объекта
   */
  message: string;

  /** Код ошибки */
  errorCode: ErrorCode;
}

export interface ValidationErrorInfo {
  /**
   * Дата и время генерации ошибки
   * @format date-time
   */
  timestamp?: string;

  /**
   * Сообщение об ошибки
   * @example Ошибка валидации
   */
  message: string;

  /** Код ошибки */
  errorCode: ErrorCode;

  /** Развернутое описание ошибки/ок */
  errorDetails?: Record<string, ValidationFieldInfo[]>;
}

/**
 * Объект для представления ошибки
 */
export interface ValidationFieldInfo {
  /**
   * Имя поля
   * @example accountNumber
   */
  fieldName: string;

  /**
   * Сообщение об ошибки
   * @example Неверный номер счета(длина не соответствует требованиям)
   */
  message: string;

  /**
   * Переданное не верное значение
   * @example 408178L0099910004312
   */
  rejectValue: string;
}

/**
 * Запрос на access token
 */
export interface GetAccessTokenReq {
  /**
   * URI для обратной переадресации после успешной аутентификации
   * @example /own-farm/main
   */
  callbackURI: string;

  /**
   * Уникальное имя внешнего партнера для формирования полного адреса forwardURL=baseURL(partnerName) + callbackURI
   * @example farming
   */
  partnerName: string;
}

/**
 * Запрос на создание транзакции в Pay Control
 */
export interface CreateTransactionRequest {
  /** Идентификатор устройства пользователя в Pay Control */
  payControlUserId: string;

  /**
   * Идентификатор организации из MS ms-org-registry (Клиентский профиль)
   * @format uuid
   */
  orgId: string;

  /** 'Отпечаток' устройства */
  fingerPrint: string;
}

/**
 * Ответ на создание транзакции в Pay Control
 */
export interface CreateTransactionResponse {
  /** Идентификатор со транзакции в Pay Control */
  transactionId: string;
}

/**
 * Запрос на проверку подтверждения транзакции
 */
export interface CheckConfirmationRequest {
  /** Идентификатор транзакции в Pay Control */
  transactionId: string;

  /** Отпечаток устройства */
  fingerPrint: string;

  /** Идентификатор пользователя в Pay Control */
  payControlUserId: string;
}

/**
 * Access token
 */
export interface AccessToken {
  /**
   * Токен доступа
   * @example eyJhbGciOiJIUzI1NiJ9.eyJwYXJhbTIiOjIsInBhcmFtMSI6InZhbDEiLCJzdWIiOiJ1c2VyMSIsImV4cCI6MTY0NTg3MjcyMSwiaWF0IjoxNjQ1Nzg2MzIxfQ.RZmrOWl31tXRHRQmQ7Z1-h_0eolFNGWxWLSV7fPFpYc
   */
  access_token: string;
}

/**
 * Запрос на аутентификацию
 */
export interface LoginPassReq {
  /**
   * Логин
   * @example user
   */
  login: string;

  /**
   * Пароль
   * @example secret
   */
  password: string;

  /**
   * Канал
   * @example mobile
   */
  channel: string;
}

export interface User {
  /**
   * Идентификатор пользователя
   * @format uuid
   * @example a1a55622-750b-11ec-b8c4-97ca1919835d
   */
  id: string;

  /**
   * Логин для входа
   * @example username
   */
  login: string;

  /**
   * Номер телефона
   * @example 79991112233
   */
  phoneNumber?: string;

  /**
   * Признак гостевой учетной записи
   * @example true
   */
  isGuest: boolean;

  /**
   * Дата создания записи
   * @format date-time
   */
  createdAt?: string;

  /**
   * Дата последнего обновления записи
   * @format date-time
   */
  updateAt?: string;

  /**
   * Признак блокировки
   * @example true
   */
  isActive: boolean;

  /**
   * Id пользователя в ДБО ЮЛ (монолит)
   * @example 123123132123
   */
  userRefId?: string;

  /**
   * Статус
   * @example active
   */
  state?: string;
}

/**
 * Параметры подтверждения одноразового пароля
 */
export interface OtpCheckReq {
  /**
   * Идентификатор запроса на формирование одноразового пароля
   * @format uuid
   * @example d77edb48-c04e-4049-a149-b552d23c730a
   */
  instanceId?: string;

  /**
   * Код подтверждения
   * @example 1234
   */
  otpCode?: string;
}

/**
 * Параметры сертификат
 */
export interface Certificate {
  /** Идентификатор сертификата. Уникален в рамках одного эмитента. */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации) */
  issuer: string;
}

/**
 * Запрос на проверку подписи
 */
export interface CheckSignatureReq {
  /**
   * Идентификатор процесса аутентификации по Сертификату
   * @format uuid
   * @example d77edb48-c04e-4049-a149-b552d23c730a
   */
  id: string;

  /** Параметры сертификат */
  certificate: Certificate;

  /**
   * Любой набор данных.
   * @example MIIMNgYJKMCAQExDj==
   */
  signedData: string;

  /**
   * Строка подписи, сформированная СКЗИ на клиенте
   * @example MIIMNgYJKMCAQExDj==
   */
  signature: string;
}

export interface DelegateInfo {
  /**
   * Идентификатор делегата
   * @format uuid
   */
  delegateId: string;

  /** Список организаций */
  org?: OrgInfo;

  /** признак блокировки делегата */
  blocked?: boolean;

  /** Признак неактивности делегата */
  isNotActive: boolean;

  /**
   * Дата начала действия полномочий
   * @format date
   */
  authorityActivateAt?: string;

  /**
   * Дата окончания действия полномочий
   * @format date
   */
  authorityExpireAt?: string;
}

export interface DelegateInfos {
  delegates?: DelegateInfo[];
}

/**
 * Список организаций
 */
export interface OrgInfo {
  /**
   * Идентификатор клиента
   * @format uuid
   */
  orgId: string;

  /** ИНН Клиента */
  inn: string;

  /** Краткое наименование Клиента */
  shortName: string;

  /** Код филиала */
  branchCode: string;

  /** Идентификатор клиента во внешней системе cft */
  cftId: string;

  /** способы аутентификации для канала */
  authTypes?: ("sms" | "cert" | "paycontrol")[];
}

export interface SendSmsResp {
  /**
   * Идентификатор запроса на формирование одноразового пароля
   * @format uuid
   * @example d77edb48-c04e-4049-a149-b552d23c730a
   */
  instanceId?: string;

  /**
   * Срок действия пароля (в секундах)
   * @format int32
   * @example 90
   */
  validityPeriod?: number;

  /**
   * Длина пароля
   * @format int32
   * @example 8
   */
  passwordLength?: number;

  /**
   * Количество секунд, через которое возможен повторный запрос пароля
   * @format int32
   * @example 100
   */
  nextRequestDelay?: number;

  /**
   * номер телефона пользователя, на который отправлена SMS
   * @example +7 (***) ***-12-34
   */
  phone: string;
}

/**
 * Параметры ответа на запрос аутентификации по сертификату
 */
export interface CertAuthResp {
  /**
   * Идентификатор процесса аутентификации по Сертификату
   * @format uuid
   * @example d77edb48-c04e-4049-a149-b552d23c730a
   */
  id: string;

  /**
   * Строка для подписи
   * @example some data
   */
  signedData: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-plt-ms-authentication
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-plt-ms-authentication.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Authentication
     * @name LoginSso
     * @summary Аутентификация через SSO
     * @request POST:/api/authentication/v1/external/loginSSO
     * @secure
     */
    loginSso: (data: LoginSsoReq, params: RequestParams = {}) =>
      this.request<LoginSsoResp, void>({
        path: `/api/authentication/v1/external/loginSSO`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name GetSsoRefreshTokenByLoginPassword
     * @summary Получение refresh-token в SSO
     * @request POST:/api/authentication/v1/external/get-sso-refresh-token-by-login-password
     * @secure
     */
    getSsoRefreshTokenByLoginPassword: (
      data: GetRefreshTokenReq,
      params: RequestParams = {}
    ) =>
      this.request<void, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/v1/external/get-sso-refresh-token-by-login-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name GetSsoAccessTokenByRefresh
     * @summary Получение access-token в SSO по refresh-token
     * @request POST:/api/authentication/v1/external/get-sso-access-token-by-refresh
     * @secure
     */
    getSsoAccessTokenByRefresh: (
      data: GetAccessTokenReq,
      params: RequestParams = {}
    ) =>
      this.request<LoginSsoResp, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/v1/external/get-sso-access-token-by-refresh`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name Logout
     * @summary Выход пользователя
     * @request POST:/api/authentication/external/v1/refresh/logout
     * @secure
     */
    logout: (params: RequestParams = {}) =>
      this.request<object, ErrorInfo>({
        path: `/api/authentication/external/v1/refresh/logout`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Первый шаг в аутентификации по Pay Control. Нужен для создания транзакции аутентификации пользователя в Pay Control
     *
     * @tags Authentication by Pay Control
     * @name CreatePayControlTransaction
     * @summary Создание транзакции в Pay Control
     * @request POST:/api/authentication/external/v1/paycontrol/transaction
     * @secure
     */
    createPayControlTransaction: (
      data: CreateTransactionRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateTransactionResponse, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/paycontrol/transaction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Третий  шаг в аутентификации по Pay Control. Получение токена после проверки транзакции
     *
     * @tags Authentication by Pay Control
     * @name CheckPayControlTransactionConfirmation
     * @summary Запрос токена для подтвержденной транзакции
     * @request POST:/api/authentication/external/v1/paycontrol/transaction/check
     * @secure
     */
    checkPayControlTransactionConfirmation: (
      data: CheckConfirmationRequest,
      params: RequestParams = {}
    ) =>
      this.request<AccessToken, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/paycontrol/transaction/check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name LoginPassword
     * @summary Аутентификация по login/password
     * @request POST:/api/authentication/external/v1/login-password
     * @secure
     */
    loginPassword: (data: LoginPassReq, params: RequestParams = {}) =>
      this.request<User, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/login-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name CheckOtp
     * @summary Аутентификация через Свой бизнес по СМС. Проверка кода
     * @request POST:/api/authentication/external/v1/login-by-sms-check-code
     * @secure
     */
    checkOtp: (data: OtpCheckReq, params: RequestParams = {}) =>
      this.request<AccessToken, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/login-by-sms-check-code`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name CheckSignature
     * @summary Аутентификация через Свой бизнес по Сертификату. Проверка подписи
     * @request POST:/api/authentication/external/v1/login-by-certificate-check-random-string
     * @secure
     */
    checkSignature: (data: CheckSignatureReq, params: RequestParams = {}) =>
      this.request<AccessToken, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/login-by-certificate-check-random-string`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name CheckSmsThirdZone
     * @summary Проверка кода в SMS для входа в миниЛК
     * @request POST:/api/authentication/external/v1/check-sms-third-zone
     * @secure
     */
    checkSmsThirdZone: (data: OtpCheckReq, params: RequestParams = {}) =>
      this.request<AccessToken, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/check-sms-third-zone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name ReturnToUser
     * @summary Возврат к первой авторизованной зоне
     * @request POST:/api/authentication/external/v1/auth-zone-exchange-two-to-one
     * @secure
     */
    returnToUser: (params: RequestParams = {}) =>
      this.request<AccessToken, ErrorInfo>({
        path: `/api/authentication/external/v1/auth-zone-exchange-two-to-one`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name AuthZoneExchangeThreeToOne
     * @summary выполнить переход из 3 авторизованной зоны в 1
     * @request POST:/api/authentication/external/v1/auth-zone-exchange-three-to-one
     * @secure
     */
    authZoneExchangeThreeToOne: (params: RequestParams = {}) =>
      this.request<AccessToken, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/auth-zone-exchange-three-to-one`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags White IP List
     * @name GetAuthMethodsInOrgsWhiteIp
     * @summary Поиск доступных организаций и методов аутентификации в них с фильтром по белым IP адресам
     * @request GET:/api/authentication/external/v1/white_address/auth-methods-in-orgs-white-ip
     * @secure
     */
    getAuthMethodsInOrgsWhiteIp: (
      query: { whiteIp: string },
      params: RequestParams = {}
    ) =>
      this.request<DelegateInfos, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/white_address/auth-methods-in-orgs-white-ip`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name SendSmsThirdZone
     * @summary Отправка кода в SMS для входа в миниЛК
     * @request GET:/api/authentication/external/v1/send-sms-third-zone/{orgId}
     * @secure
     */
    sendSmsThirdZone: (orgId: string, params: RequestParams = {}) =>
      this.request<SendSmsResp, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/send-sms-third-zone/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name GetAccessTokenByRefreshToken
     * @summary Получение access-token по refresh-token
     * @request GET:/api/authentication/external/v1/refresh/get-access-by-refresh
     * @secure
     */
    getAccessTokenByRefreshToken: (params: RequestParams = {}) =>
      this.request<AccessToken, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/refresh/get-access-by-refresh`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name AuthenticateBySms
     * @summary Аутентификация через Свой бизнес по СМС. Отправка кода
     * @request GET:/api/authentication/external/v1/login-by-sms-send-code/{orgId}
     * @secure
     */
    authenticateBySms: (orgId: string, params: RequestParams = {}) =>
      this.request<SendSmsResp, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/login-by-sms-send-code/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name AuthenticateByCert
     * @summary Аутентификация через Свой бизнес по Сертификату. Отправка случайной строки
     * @request GET:/api/authentication/external/v1/login-by-certificate-send-random-string/{orgId}
     * @secure
     */
    authenticateByCert: (orgId: string, params: RequestParams = {}) =>
      this.request<CertAuthResp, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/login-by-certificate-send-random-string/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name GetAuthMethodsInOrgs
     * @summary Поиск доступных организаций и методов аутентификации в них
     * @request GET:/api/authentication/external/v1/get-auth-methods-in-orgs
     * @secure
     */
    getAuthMethodsInOrgs: (params: RequestParams = {}) =>
      this.request<DelegateInfos, ValidationErrorInfo | ErrorInfo>({
        path: `/api/authentication/external/v1/get-auth-methods-in-orgs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
